import React, { useEffect, useState } from "react"
import ClientReportCard from "../../components/ClientReportCard.molecule"
import { getClientReportNotes } from "../../../../services/clientReport.service"
import { CLIENT_REPORT_GROUP_SPRINTS_GROUP_BY } from "../../../../consts/modules/clientReport.consts"
import Notes from "../../../../design/assests/images/icons/Notes.svg"

const renderTextWithBullets = (text = "") => {
  const lines = text.split("\n")
  const elements = []
  let bullets = []

  const bulletRegex = /^-\s*(.+)$/

  lines.forEach((line, idx) => {
    const trimmed = line.trim()

    const match = trimmed.match(bulletRegex)

    if (match) {
      bullets.push(match[1])
      return
    }

    if (bullets.length) {
      elements.push(
        <ul
          key={`ul-${idx}`}
          className="client-report-notes-text m-0 mb-3 pl-4"
        >
          {bullets.map((item, i) => (
            <li key={i}>{item}</li>
          ))}
        </ul>
      )
      bullets = []
    }

    if (trimmed) {
      elements.push(
        <p key={idx} className="client-report-notes-text m-0 mb-3">
          {trimmed}
        </p>
      )
    }
  })

  // flush final bullets
  if (bullets.length) {
    elements.push(
      <ul key="ul-last" className="m-0 pl-4">
        {bullets.map((item, i) => (
          <li key={i}>{item}</li>
        ))}
      </ul>
    )
  }

  return elements
}

const ClientReportNotes = ({
  sprintData,
  period,
  refresh,
  collapsible = true,
  isPresentationMode = false,
}) => {
  const normalizedPeriod = period?.toUpperCase()
  if (
    normalizedPeriod !== CLIENT_REPORT_GROUP_SPRINTS_GROUP_BY.BLOCK &&
    normalizedPeriod !== CLIENT_REPORT_GROUP_SPRINTS_GROUP_BY.CYCLE
  ) {
    return null
  }

  const [notes, setNotes] = useState("")
  const [loading, setLoading] = useState(true)
  const periodId = sprintData?.periodId
  const periodType = sprintData?.periodType?.toUpperCase()

  useEffect(() => {
    fetchNotes()
  }, [periodId, periodType, refresh])

  const fetchNotes = async () => {
    if (!periodId || !periodType) {
      setNotes("")
      setLoading(false)
      return
    }

    setLoading(true)

    try {
      const response = await getClientReportNotes(periodId, periodType)

      if (!response?.success) {
        throw new Error(response?.message)
      }

      setNotes(response?.result?.reportNotes || "")
    } catch (error) {
      console.error(error)
      setNotes("")
    } finally {
      setLoading(false)
    }
  }

  if (loading || !notes?.trim()) {
    return null
  }

  return (
    <ClientReportCard
      collapsible={collapsible}
      title="Notas del reporte"
      icon={<img src={Notes} className="client-report-notes-icon" />}
      className="font-cairo w-full"
    >
      <div className="client-report-notes-text">
        {renderTextWithBullets(notes)}
      </div>
    </ClientReportCard>
  )
}

export default ClientReportNotes
